import { getWorkspaceCounters } from '@api/Workspace';
import {
  IWorkspaceCountersAction,
  WorkspaceCountersTypes
} from '@redux/types/workspaceCountersType';
import { Dispatch } from 'react';

export const setWorkspaceCounters =
  (workspaceId: string) =>
  async (dispatch: Dispatch<IWorkspaceCountersAction>) => {
    const { data } = await getWorkspaceCounters(workspaceId);

    dispatch({
      type: WorkspaceCountersTypes.SET_WORKSPACE_COUNTERS,
      payload: {
        ...data,
        workspaceId
      }
    });
  };

export const updateWorkspaceCounters = ({
  isTaskCounter,
  entity,
  count
}: {
  isTaskCounter?: boolean;
  entity: string;
  count: number;
}) => ({
  type: WorkspaceCountersTypes.UPDATE_WORKSPACE_COUNTERS,
  payload: { isTaskCounter, entity, count }
});
